<!-- MTKのボトムのOKボタン -->
<!-- 一旦stortbookなし -->
<template>
  <button
    :disabled="!radio.id"
    class="bottom-button"
    @click="dealingEachTicket(radio)"
  >
    OK
  </button>
  <!-- ボトムのOKボタン -->
</template>

<script>
import MTKMixin from "@/mixins/SetQR/MTKMixin";

export default {
  name: "MTKBottomButton",
  mixins: [MTKMixin],
  props: {
    radio: {
      type: Object,
      required: true,
    },
  },
  methods: {
    dealingEachTicket(info) {
      console.log("info :>> ", info);
      if (info.type == "pass") {
        this.gotoPass(info.bookgroup, info.master_id, info.id);
      } else {
        this.gotoSheetValid(
          info.bookgroup,
          info.master_id,
          info.id,
          this.$route.fullPath.split("?")[1]
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom-button {
  background: #fdc138;
  width: 100vw;
  display: block;
  border: none;
  font-size: 1rem;
  color: white;
  font-weight: bold;
  padding: 2vh;
  position: fixed;
  bottom: 0;
}

.bottom-button:disabled {
  background: #dadada;
}
</style>
